<div class="table">
  <div class="table-height">
    <div class="table-box">
      <table>
        <thead>
          <tr>
            @for (propriete of proprietesAffichees(); track propriete; let i = $index) {
              <th width="{{table_width[i] + '%' }}"
                [title]="propriete.libelleAffiche | translate">
                <div style="cursor: pointer;">
                  <span (click)="sortBy(propriete, i)">{{ propriete.libelleAffiche | translate }}
                    <i class="fas" [class.fa-sort-down]="arrowSort()[i] && i == activeSort()"
                    [class.fa-sort-up]="!arrowSort()[i] || i != activeSort()"></i>
                  </span>
                </div>
              </th>
            }
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody  >
          @for (r of tabRockTypes(); track r.id; let i = $index) {
            <tr  (click)="selectRockType($event, r)"   >
              <td  style="padding-left: 10px;">{{ r.id }}</td>
              <td>
                <span > {{r.name}} </span>
              </td>
              <td>
                <span > {{r.compressiveStrength}} </span>
              </td>
              <td>
                <span > {{r.youngModulus}} </span>
              </td>
              <td>
                <span > {{r.shearModulus}} </span>
              </td>
              <td>
                <span > {{r.theoreticalSpeed}} </span>
              </td>
              <td>
                <span > {{r.poissonRatio}} </span>
              </td>
              <td>
                <span > {{r.rqd}} </span>
              </td>
              <td>
                <span > {{r.density}} </span>
              </td>
            </tr>
          }

        </tbody>
      </table>
    </div>
  </div>
  <div class="footer">
    <button class="btn btn-primary" style="margin-left:5px;" (click)="ouvrirModaleAdd()"><i style="margin-right:2px;"
    class="fas fa-plus"></i>{{'GLOBAL.AJOUTER' | translate}}</button>
  </div>
</div>